module.exports = __webpack_public_path__ + "static/img/gold.bd21a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/gold.png
// module id = poct
// module chunks = 215